import { combineReducers } from 'redux';
import { performanceSlice } from '~/pages/Dashboard/AnalyticsBox/reports/Performance/performanceSlice';
import { characterClassSlice } from '~/pages/Dashboard/AnalyticsBox/reports/CharacterClass/characterClassSlice';
import { powerSlice } from '~/pages/Dashboard/AnalyticsBox/reports/Power/powerSlice';
import { upgradeSlice } from '~/pages/Dashboard/AnalyticsBox/reports/Upgrade/upgradeSlice';
import { winRateSlice } from '~/pages/Dashboard/AnalyticsBox/reports/WinRate/winRateSlice';

export const dashboardReducers = combineReducers({
    performance: performanceSlice.reducer,
    characterClass: characterClassSlice.reducer,
    power: powerSlice.reducer,
    upgrade: upgradeSlice.reducer,
    winRate: winRateSlice.reducer,
});
